import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { deleteUser } from '@actions/users/deleteUser';
import { getUserPostSuccess, getUserIsPosting, getUsersError } from '@selectors/users';

export default function useDeleteUser(userID: number): UseDeleteUserReturn {
    const dispatch = useDispatch();

    const handleSubmit = useCallback(() => {
        dispatch(deleteUser(userID));
    }, [dispatch, userID]);

    const isPosting = useSelector(getUserIsPosting);
    const error = useSelector(getUsersError);
    const deleteSuccess = useSelector(getUserPostSuccess);

    return {
        handleSubmit,
        isPosting,
        error,
        deleteSuccess,
    };
}

interface UseDeleteUserReturn {
    handleSubmit: () => void;
    isPosting: boolean;
    error: string | null;
    deleteSuccess: boolean;
}
